export default "__VITE_ASSET__a81d2d3c__"